import {
  BorderOutlined,
  CaretDownOutlined,
  CaretRightOutlined,
  FontSizeOutlined,
} from '@ant-design/icons';
import { ElemTypes } from 'common/interfaces';
import { MouseEvent } from 'react';

export const getLayerItemIconByElemType = (
  elemType: ElemTypes,
  showChildren: boolean,
  toggleNestedListHandler: (e: MouseEvent<HTMLDivElement>) => void,
): JSX.Element => {
  switch (elemType) {
    case ElemTypes.BLOCK:
      return <BorderOutlined />;
    case ElemTypes.GROUP:
      return showChildren ? (
        <CaretDownOutlined onMouseDown={toggleNestedListHandler} />
      ) : (
        <CaretRightOutlined onMouseDown={toggleNestedListHandler} />
      );
    case ElemTypes.TEXT:
      return <FontSizeOutlined />;
    default:
      return <BorderOutlined />;
  }
};
